import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { ObjectObservable } from '../../shared/base/object-observable';
import { Lecture } from '../shared/lecture';
import { APPCONFIG } from "../../config";

@Component({
  selector: 'app-lecture-syllabus',
  templateUrl: './lecture-syllabus.component.html',
  styleUrls: ['./lecture-syllabus.component.scss']
})
export class LectureSyllabusComponent implements OnInit {
  lectureObservable: ObjectObservable<Lecture>;
  private AppConfig: any;

  constructor(private route: ActivatedRoute, private router: Router, private auth: AuthService) { }

  ngOnInit() {
    this.route.parent.parent.data.subscribe((data: { lecture: ObjectObservable<Lecture> }) => this.lectureObservable = data.lecture);
    this.AppConfig = APPCONFIG;
  }

  onEdit() {
    this.router.navigate(['edit'], { relativeTo: this.route.parent.parent });
  }

  get isAuthenticated() {
    return this.auth.isAuthenticated;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-syllabus/lecture-syllabus.component.ts